<sl-form-view [mainPageActions]="currentActions" [shouldDisplayHeader]="false">
    @if (!!reportUrl()) {
        <mat-card appearance="outlined" class="mat-elevation-z4">
            <mat-card-content>
                <div class="report-wrapper">
                    @if (!hasReportLoaded()) {
                        <div class="center-loader">
                            <mat-spinner />
                        </div>
                    }
                    <iframe width="100%" height="1280px" [src]="reportUrl() | safeUrl" (load)="markReportAsLoaded()"></iframe>
                </div>
            </mat-card-content>
        </mat-card>
    }
</sl-form-view>
